import { dateUtils } from '../../utils/dateUtils';

export const pdfComponents = {
  buildHeader: (docTitle, projectMeta, docId, revision) => {
    return {
      table: {
        widths: ['*', 'auto'],
        body: [
          [
            {
              text: [
                { text: 'Civil Nexus Engineering Record\n', style: 'subHeader', alignment: 'left' },
                { text: docTitle, style: 'header', alignment: 'left' }
              ],
              border: [false, false, false, true]
            },
            {
              text: [
                `شناسه سند: ${docId}\n`,
                `شماره ویرایش: ${revision}\n`,
                `تاریخ صدور: ${dateUtils.formatJalali(dateUtils.now())}`
              ],
              alignment: 'right',
              fontSize: 9,
              bold: true,
              border: [false, false, false, true]
            }
          ]
        ]
      },
      margin: [0, 0, 0, 20]
    };
  },

  buildProjectMeta: (meta) => {
    return {
      table: {
        widths: ['25%', '25%', '25%', '25%'],
        body: [
          [
            { text: `پروژه: ${meta.title || '---'}`, colSpan: 2, bold: true }, {},
            { text: `محل اجرا: ${meta.location || '---'}`, colSpan: 2 }, {}
          ],
          [
            { text: `کارفرما: ${meta.client || '---'}` },
            { text: `مشاور: ${meta.consultant || '---'}` },
            { text: `پیمانکار: ${meta.contractor || '---'}`, colSpan: 2 }, {}
          ]
        ]
      },
      layout: 'lightHorizontalLines',
      margin: [0, 0, 0, 15],
      fontSize: 9
    };
  },

  buildSignatures: () => {
    return {
      table: {
        widths: ['*', '*', '*'],
        body: [
          [
            { text: 'نماینده پیمانکار\n\n\n\nمهر و امضا', alignment: 'center', margin: [0, 10, 0, 10], border: [false, true, false, false] },
            { text: 'دستگاه نظارت مقیم\n\n\n\nمهر و امضا', alignment: 'center', margin: [0, 10, 0, 10], border: [false, true, false, false] },
            { text: 'نماینده کارفرما\n\n\n\nمهر و امضا', alignment: 'center', margin: [0, 10, 0, 10], border: [false, true, false, false] }
          ]
        ]
      },
      margin: [0, 40, 0, 0]
    };
  },

  buildAuditFooter: (auditHash, docId) => {
    return {
      columns: [
        {
          qr: `CN-DOC:${docId}\nHASH:${auditHash}`,
          fit: 60,
          alignment: 'left'
        },
        {
          text: [
            'این سند توسط سامانه مهندسی Civil Nexus صادر شده و در دیتابیس کارگاهی ثبت گردیده است.\n',
            { text: `SHA-256 Audit Hash:\n${auditHash}`, style: 'auditHash' }
          ],
          margin: [15, 10, 0, 0],
          alignment: 'left'
        }
      ],
      margin: [0, 30, 0, 0]
    };
  }
};
